import { Button, ButtonGroup } from '@mui/material';
import { Tooltip } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import { customButtonStyle } from './customActionStyles';

import styles from './GateActions.module.css';

const SelectMicrophone = () => {
    return (
        <div className={styles['window-gate-actions--wrapper']}>
            <div className={styles['window-gate-actions--label']}>
                <span>Select a microphone</span>
                <div className={styles['window-gate-actions--value']}>
                    <span>Alt + M</span>
                </div>
            </div>
            <Tooltip title="Microphones are coming soon.">
                <ButtonGroup variant="contained" aria-label="Basic button group" sx={{ gap: '1px', boxShadow: 'none' }}>
                    <Button variant="contained" color="primary" size="small" startIcon={<MicIcon />} sx={customButtonStyle} disabled>
                        C12 ID
                    </Button>
                    <Button variant="contained" color="primary" size="small" startIcon={<MicIcon />} sx={customButtonStyle} disabled>
                        C13 ID
                    </Button>
                </ButtonGroup>
            </Tooltip>
        </div>
    );
};

export default SelectMicrophone;
